import { render, staticRenderFns } from "./whitelists.vue?vue&type=template&id=2a18e781&"
import script from "./whitelists.vue?vue&type=script&lang=js&"
export * from "./whitelists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports